export const formatNewsDate = (dateString) => {
  if (!dateString) return 'Unknown';
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);

    if (diffHours < 1) return 'Just now';
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  } catch {
    return 'Unknown';
  }
};

export const sentimentColor = (score) => {
  if (score > 0.1) return 'bg-green-100 text-green-700 border-green-200';
  if (score < -0.1) return 'bg-red-100 text-red-700 border-red-200';
  return 'bg-gray-100 text-gray-700 border-gray-200';
};

export const sentimentLabel = (score) => {
  if (score > 0.3) return 'Very Bullish';
  if (score > 0.1) return 'Bullish';
  if (score < -0.3) return 'Very Bearish';
  if (score < -0.1) return 'Bearish';
  return 'Neutral';
};
